import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import React from 'react';
import { Icon } from '../../Icon';
import styles from './Tab.Setting.scss';
export var TabSetting = function TabSetting(props) {
  var _classnames;

  var isActiveTab = props.activeTabIndex === props.index;
  var isRightOfActiveTab = props.index === props.activeTabIndex + 1;
  var isInactiveTab = !isActiveTab && !isRightOfActiveTab;
  var classes = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(styles.settingsTab), isActiveTab || isInactiveTab), _defineProperty(_classnames, "".concat(styles.settingsTabActive), isActiveTab), _defineProperty(_classnames, "".concat(styles.rightOfActive), isRightOfActiveTab), _defineProperty(_classnames, "".concat(styles.grayBackground), isActiveTab && props.activeBackgroundColor === "gray"), _defineProperty(_classnames, "".concat(styles.whiteBackground), isActiveTab && props.activeBackgroundColor === "white"), _classnames));
  return React.createElement("div", {
    role: "presentation",
    className: classnames(styles.settingsTabContainer)
  }, React.createElement("button", {
    type: "button",
    role: "tab",
    title: "settings",
    className: classes,
    onClick: function onClick() {
      return props.onTabClicked(props.index);
    },
    "data-test": props.dataTest
  }, React.createElement(Icon, {
    icon: "utility-settings",
    className: styles.settingsIcon
  }), React.createElement("span", null, "settings")));
};